"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordingType = exports.RecordingAction = void 0;
var RecordingAction = exports.RecordingAction = /*#__PURE__*/function (RecordingAction) {
  RecordingAction["Start"] = "Start";
  RecordingAction["Stop"] = "Stop";
  RecordingAction["Pause"] = "Pause";
  RecordingAction["Resume"] = "Resume";
  return RecordingAction;
}({});
var RecordingType = exports.RecordingType = /*#__PURE__*/function (RecordingType) {
  RecordingType["Premise"] = "premise";
  RecordingType["Cloud"] = "cloud";
  return RecordingType;
}({});
//# sourceMappingURL=enums.js.map
